// src/services/auth.js
import api from "./api";

/**
 * Login
 * POST /auth/login
 * Expected response:
 * {
 *   accessToken: string,
 *   user: {...}
 * }
 */
export async function login(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}

/**
 * Register
 */
export async function signup({
  userName,
  email,
  password,
  referrerCode = "",
  isAdminRegistration = false,
  adminInheritedAddresses = [],
  adminMaintenanceAddress = ""
}) {
  const { data } = await api.post("/auth/register", {
    userName,
    email,
    password,
    referrerCode,
    isAdminRegistration,
    adminInheritedAddresses,
    adminMaintenanceAddress
  });
  return data;
}

/**
 * Logout (optional backend support)
 */
export async function logout() {
  try {
    await api.post("/auth/logout");
  } catch {
    // backend logout optional
  }
}

/**
 * Get current user
 */
export async function fetchCurrentUser() {
  const { data } = await api.get("/auth/me");
  return data?.user || null;
}
